// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"breadcrumb_breadcrumbs__igxFI","link_area":"breadcrumb_link_area__Lit_n","link":"breadcrumb_link__B_9dj"};